import { forwardRef } from 'react';
import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { PARENT_MENU_ITEM_DATA_ATTRIBUTE } from '@/components/Recipe/Menu/hooks/useParentMenuHelper';

import type { MenuItemProps as MuiMenuItemProps } from '@mui/material';

export type MenuItemProps = MuiMenuItemProps;

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  justifyContent: 'space-between',
  borderRadius: theme.spacing(0.5),
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  fontWeight: 400,
  '&:hover': {
    backgroundColor: token.bgSelected,
  },
  '&:focus': {
    outline: 'none',
  },
  '&:focus-visible:not(:hover)': {
    outline: `1px solid ${token.border}`,
    outlineOffset: '-1px',
  },
  '&:focus:not(:hover)': {
    backgroundColor: 'transparent',
  },
  '&.Mui-focusVisible:not(:hover)': {
    backgroundColor: 'transparent',
  },
  '& + .MuiDivider-root': {
    marginTop: 0,
    marginBottom: 0,
  },
}));

export const AppMenuItem = forwardRef<HTMLLIElement | null, MenuItemProps>(function AppMenuItem(props, ref) {
  const handleMouseEnter = (e: React.MouseEvent<HTMLLIElement>) => {
    // Blur any focused parent menu item when hovering over this item, we are querying the dom directly because currently AppContextMenu is not aware of its children, so we can't manage it on that level
    const focusedElement = document.activeElement;
    if (
      focusedElement &&
      focusedElement.tagName === 'LI' &&
      focusedElement.getAttribute(PARENT_MENU_ITEM_DATA_ATTRIBUTE) === 'true' &&
      focusedElement !== e.currentTarget
    ) {
      (focusedElement as HTMLElement).blur();
    }

    // Call original onMouseEnter if provided
    props.onMouseEnter?.(e);
  };

  return <StyledMenuItem {...props} ref={ref} onMouseEnter={handleMouseEnter} />;
});
